/* istanbul ignore file */
import useStateMachine from './useStateMachine';

export default useStateMachine;
